/**
 * This function refactor the comma separated locations string to a more readable format.
 * @param locations - The locations of the installation (Alkmaar, Bergen, Heerhugowaard).
 * @returns A readable format of the locations (Alkmaar, Bergen en Heerhugowaard).
 */
export const locationsFormatter = (locations: string | null | undefined) => {
  return locations?.replace(/,([^,]*)$/, ' en$1');
};
